import usePosOrderCurrentAction from "@/shared/atoms/usePosOrderCurrentAction";
import { useSetModal } from "@/shared/atoms/useModal";
import {
  useHasSession,
  useShowPayments,
} from "@/shared/hooks/usePosOrderTableSessionHook";
import useActionClick from "./useActionClick";
import PosMenuBottomActionButton, {
  PosMenuAction,
} from "../PosMenu/PosMenuBottomActionButton";
import { useTranslation } from "react-i18next";
import { CurrentActionTypes } from "@/shared/atoms/usePosOrderCurrentAction";
import useDiscountCodeHook from "@/shared/hooks/useDiscountCodeHook";

const usePosOrderDiscountCodeAction = (): PosMenuAction => {
  const { t } = useTranslation();
  const hasSession = useHasSession();
  const showPayments = useShowPayments();
  const setModal = useSetModal();
  const { resetDiscountCode, discountCode } = useDiscountCodeHook();

  return {
    name: "posOrderDiscountCode" as CurrentActionTypes,
    label: t("posOrders.discountCode"),
    set: () => setModal("posOrderDiscountCode"),
    deleteAction: () => resetDiscountCode(),
    hasDeleteAction: discountCode.code.length > 0,
    instantSet: true,
    filtered: false,
    disabled: hasSession ? showPayments : false,
    iconVariant:"keyboard",
  };
};

const PosOrderDiscountCodeAction = () => {
  const [currentAction] = usePosOrderCurrentAction();
  const action = usePosOrderDiscountCodeAction();
  const handleClick = useActionClick(action);

  return (
    <PosMenuBottomActionButton
      action={action}
      isSelected={currentAction?.name === action.name}
      onClick={handleClick}
    />
  );
};

export default PosOrderDiscountCodeAction;
